import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextNotification, severitys } from '../../../App';
import packageApi from '../../../api/packageApi';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import { ContextUserInfo } from '../../../Layout/MainLayout';
import helper from '../../../helper';
import { Box, Chip, ThemeProvider, Typography } from '@mui/material';
import RtlProvider from '../../../Components/RtlProvider';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import '../../../Styles/Timeline.css'
import EnumMapper from '../../../EnumMapper';
const PackagePanel = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const customization = useSelector((state) => state.customization);
  const schema = yup.object().shape({

  });
  const { register, handleSubmit, formState: { errors }, control, watch, setValue, resetField } = useForm({
    defaultValues: {

    },
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  const [packageDropDown, setPackageDropDown] = useState([]);
  const [packageInfo, setPackgeInfo] = useState(null)
  useEffect(() => {
    GetPackageDropdown();
  }, []);

  const GetPackageDropdown = () => {
    packageApi.DropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        })
        setPackageDropDown(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const handlePackageChanged = (id) => {
    setPackgeInfo(null)
    if (id) {
      packageApi.CustomGetByKey(id)
        .then(res => {
          setPackgeInfo(res.data.data)
        })
        .catch(err => console.log(err))
    }
  }
  return (
    <ThemeProvider theme={customtheme(customization)}>
      <RtlProvider>
        <RHFAutocomplete
          control={control}
          options={packageDropDown ?? []}
          name="packageId"
          placeholder="برنامه سفر"
          onChange={handlePackageChanged}
          style={{
            border: "none",
            padding: 0,
            width: '200px'
          }}
        />
        <p className="error">{errors.packageId?.message}</p>
        {
          packageInfo &&

          <ul class="timeline">
            {packageInfo.details.sort((a, b) => a.order >= b.order ? 1 : -1).map((item, index) => (
              <li>
                <div class={item.order % 2 ? "direction-l" : "direction-r"}>
                  <div class="flag-wrapper">
                    <span class="hexa"></span>
                    <Typography class="flag">{item.title}</Typography>
                    <span class="time-wrapper"><span class="time">{packageInfo.isDefault? item.order+1:item.order}</span></span>
                  </div>

                  {item.events.map((eventItem) => (
                    <div class="desc">
                      <Typography sx={{ fontSize: 17, mb: 2 }}>{eventItem.eventTypeTitle}</Typography>
                      <Typography sx={{lineHeight:2}}>{eventItem.description}</Typography>
                      {
                        (eventItem.eventType === EnumMapper.PackageDetailsEventType.InterCity ||
                          eventItem.eventType === EnumMapper.PackageDetailsEventType.Cargo) ? <>
                          <Typography sx={{lineHeight:2}}>از {eventItem.fromCityTitle} به {eventItem.toCityTitle}</Typography>
                        </> : <>
                          <Typography sx={{lineHeight:2}}>{eventItem.fromCityTitle}</Typography>
                          <Typography sx={{lineHeight:2}}>{eventItem.toCityTitle}</Typography></>
                      }

                      {/* <Typography sx={{lineHeight:2}}>{eventItem.start}</Typography> */}
                    
                      {/* <Typography>{eventItem.end}</Typography> */}
                    </div>
                  ))}

                </div>
              </li>
            ))
            }

          </ul>
        }

      </RtlProvider>
    </ThemeProvider>
  )
}

export default PackagePanel